// @flow
import React, { useCallback, useMemo } from 'react';
import reduce from 'ramda/es/reduce';

import { Row, Cell } from 'app/common/components/Table';
import toFixedValue from 'app/common/lib/toFixedValue';

import styles from './RowClickable.module.scss';;


type Props = {
  loading: boolean,
  id: string,
  onClick: (id: string) => void,
  items?: Array<{
    total: number,
  }>
}

const RowClickable = ({ items, loading, id, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(id);
  }, [onClick, id]);

  const total = useMemo(() => (items
    ? toFixedValue(reduce((sum, { total: t }) => (sum + t), 0, items))
    : null
  ), [items]);

  return (
    <Row
      className={styles.root}
      loading={loading}
      onClick={handleClick}
    >
      <Cell className={styles.dates}>{id}</Cell>
      <Cell grow={10}>{total === null ? '—' : total}</Cell>
    </Row>
  );
};

export default RowClickable;
